import cleanedFilename from '~/util/cleanedFilename';

export default {
  LOADING_BODY: `${cleanedFilename(__filename)}-loading-body`,
};
